import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";

import { Actions as ASSETACTIONS } from "../../store/actions/assetActions";
import { Actions as EMPLOYEEACTIONS } from '../../store/actions/employeeActions';

import AssetRow from "./AssetRow";
import _ from "lodash";
import { PlusIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import LoadingContent from "../common/LoadingContent";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import NewAssetModal from "./modals/NewAssetModal";
import { addMonths, format } from "date-fns";

const Assets = ({
  listAssets,
  assets,
  permission,
  toggleNewModal,
  employeesGetListWithSalary,
  employeeListWithSalary
}) => {
  const [search, setSearch] = useState("");

  useEffect(() => {
    employeesGetListWithSalary()
  }, [])

  useEffect(() => {
    if (employeeListWithSalary) listAssets();
  }, [employeeListWithSalary]);

  const filteredAssetList = useMemo(() => {
    const filterByValue = (o) =>
      ["id", "name", "reference", "type", "subType", "agreement", "employeeName"].some((k) =>
        String(o[k]).toLowerCase?.().includes(search.toLowerCase?.())
      );

    return (
      assets && (search && search != "" ? assets.filter(filterByValue) : assets)
    );
  }, [search, assets]);

  if (!permission) return <InvalidPermissions />

  return (
    <>
      {assets ? (
        <>
          <div className="content bg-gray-lighter">
            <div className="row">
              <div className="col-sm-12">
                <div className="pull-left">
                  <h1 className="page-heading">Assets</h1>
                </div>

                <div
                  className="btn btn-success pull-right"
                  onClick={() => toggleNewModal()}
                >
                  <PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                  <div style={{ float: "left" }}>Add New Asset</div>
                </div>
              </div>
            </div>
          </div>

          <NewAssetModal />

          <div className="content mb-32">
            <div id="assets">
              <div
                style={{
                  border: "1px solid #bbbcbc",
                  borderBottom: "none",
                  position: "relative",
                }}
              >
                <MagnifyingGlassIcon
                  className={"text-gray"}
                  style={{
                    height: "1.5em",
                    position: "absolute",
                    margin: "0.75em",
                  }}
                ></MagnifyingGlassIcon>
                <input
                  name="search"
                  onChange={(e) => setSearch(e.target.value)}
                  value={search}
                  style={{
                    border: "none",
                    display: "inline-block",
                    maxWidth: "100%",
                    width: "100%",
                    padding: 10,
                    paddingLeft: 40,
                  }}
                  autoComplete='off'
                />
              </div>

              <div className="table-responsive">
                <div
                >
                  <table
                    className="js-table-sections table table-hover"
                  >
                    <thead style={{ display: "table-header-group" }}>
                      <tr>
                        <th></th>
                        <th>NAME</th>
                        <th>REFERENCE</th>
                        <th>TYPE</th>
                        <th>SUBTYPE</th>
                        {/* <th>ASSET ID</th> */}
                        {/* <th>D.O.S</th> */}
                        <th>CURRENT EMPLOYEE</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredAssetList.map((asset) => (
                        <AssetRow key={asset.id} asset={asset} />
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      ) :
        <LoadingContent />
      }
    </>
  );
};

const mapStateToProps = (state) => {
  const assets = state.asset?.list;

  return {
    assets,
    permission: state?.permissions?.my?.permissions?.assets != 'None',
    employeeListWithSalary: !!state.employees?.employeeListWithSalary
  };
};

const mapDispatchToProps = (dispatch) => ({
  listAssets: () => dispatch(ASSETACTIONS.getAssets()),
  toggleNewModal: () => {
    dispatch(ASSETACTIONS.clearAsset())
    dispatch(ASSETACTIONS.toggleNewModal(true))
  },
  employeesGetListWithSalary: () =>
    dispatch(
      EMPLOYEEACTIONS.employeesGetListWithSalary({
        from: format(addMonths(new Date(), -12), 'yyyy-MM-01'),
        to: format(new Date(), 'yyyy-12-31'),
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Assets);
